import { EventEmitter } from '@angular/core';
import type { RelayCommandInterface } from '@nts/std/interfaces';
import { UUIDHelper } from '@nts/std/utility';
import { BehaviorSubject, Observable, takeUntil } from 'rxjs';

export class RelayCommand implements RelayCommandInterface {

  private internalHiddenOnMobile = false;
  private internalHiddenOnDesktop = false;

  name: string;
  tag: object;
  executed: EventEmitter<any> = new EventEmitter<any>();
  displayName$ = new BehaviorSubject<string>('');
  tooltip$ = new BehaviorSubject<string>('');
  iconClass$ = new BehaviorSubject<string>('');
  loading$ = new BehaviorSubject<boolean>(false);
  showDisplayName$ = new BehaviorSubject<boolean>(true);
  isVisible$ = new BehaviorSubject<boolean>(true);
  canExecute$ = new BehaviorSubject<boolean>(true);
  hiddenOnMobile$ = new BehaviorSubject<boolean>(this.internalHiddenOnMobile);
  hiddenOnDesktop$ = new BehaviorSubject<boolean>(this.internalHiddenOnDesktop);
  data: any;
  isCancel = false;
  uid: string;
  destroySubscribers$: EventEmitter<void> = new EventEmitter<void>();

  protected _execute: (x: any, y?: any) => void;

  constructor(
    canExecute: () => Observable<boolean>,
    execute: (x: any) => void,
    isVisible: () => Observable<boolean> = null
  ) {
    if (execute == null) {
      throw new Error('ArgumentNullException: execute');
    }

    this._execute = execute;
    if (isVisible != null) {
      isVisible().pipe(
        takeUntil(this.destroySubscribers$)
      ).subscribe({
        next: (isVisible) => {
          this.isVisible$.next(isVisible);
        },
        error: (err) => {
          this.isVisible$.error(err);
        },
        complete: () => {
          // this.isVisible$.complete()
        },
      });
    }
    if (canExecute != null) {
      canExecute().pipe(
        takeUntil(this.destroySubscribers$)
      ).subscribe({
        next: (canExecute) => {
          this.canExecute$.next(canExecute);
        },
        error: (err) => {
          this.canExecute$.error(err);
        },
        complete: () => {
          // this.canExecute$.complete()
        },
      });
    }
    this.uid = UUIDHelper.generateUUID();
  }

  destroy(destroyAll?: boolean): void {

    this.destroySubscribers$?.next();
    this.destroySubscribers$?.complete();
    this.destroySubscribers$ = null;

    this.executed?.complete();
    this.executed = null;

    this.displayName$?.complete();
    this.displayName$ = null;

    this.tooltip$?.complete();
    this.tooltip$ = null;

    this.iconClass$?.complete();
    this.iconClass$ = null;

    this.loading$?.complete();
    this.loading$ = null;

    this.showDisplayName$?.complete();
    this.showDisplayName$ = null;

    this.isVisible$?.complete();
    this.isVisible$ = null;

    this.canExecute$?.complete();
    this.canExecute$ = null;

    this.hiddenOnMobile$?.complete();
    this.hiddenOnMobile$ = null;

    this.hiddenOnDesktop$?.complete();
    this.hiddenOnDesktop$ = null;

    this.tag = null;
    this.data = null;

    this._execute = null;

  }

  execute(parameter: any, otherParam?: any) {
    this._execute(parameter, otherParam);
    this.executed.emit(parameter);
  }

  get hiddenOnMobile(): boolean {
    return this.internalHiddenOnMobile;
  }

  set hiddenOnMobile(value: boolean) {
    this.internalHiddenOnMobile = value;
    this.hiddenOnMobile$.next(this.internalHiddenOnMobile);
  }

  get hiddenOnDektop(): boolean {
    return this.internalHiddenOnDesktop;
  }

  set hiddenOnDesktop(value: boolean) {
    this.internalHiddenOnDesktop = value;
    this.hiddenOnDesktop$.next(this.internalHiddenOnDesktop);
  }
}
